module.exports = __webpack_public_path__ + "static/img/monthly-price-discount-39.4740403.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/LimitedTimeOfferAd/monthly-price-discount-39.png
// module id = CS9R
// module chunks = 1